<div class="loading-container" *ngIf="showSpinner">
  <div class="loading-gif">
    <img src="../assets/images/Spinner.gif">
  </div>
</div>

<div class="row mb-2">
  <div class="col-md-12">
    <ngx-datatable
    name="clientFilesTable"
    class="material striped"
    style="height:800px"
    [columnMode]="'force'"
    [columns]="columns"
    [headerHeight]="50"
    [footerHeight]="false"
    [count]="rows.length"
    [rowHeight]="rowHeight"
    [rows]="rows"
    [scrollbarV]="true"
    [virtualization]="false"
    [selectionType]="'single'"
    [selected]="selected"
    (activate)="handleSelect($event)"
    ></ngx-datatable>
  </div>
</div>

<button class="btn" disabled="true"><i class="fa fa-plus-circle"></i> Add New Configuration</button>
